<template>
  <div class="bg-white container position-fixed-top border col-lg-8 rounded shadow p-lg-4">
    <h4>Add Performance</h4>
    <b-col class="m-auto p-0 p-md-3">
    <b-form @submit="onSubmit">
      <b-form-group  label="Performance ID:" label-for="input-a">
        <b-form-input
          id="input-a"
          v-model="form.performance_id"
          type="text"
          required
          placeholder="Enter Performance ID"
        ></b-form-input>
      </b-form-group>
      
      <b-form-group  label="Name:" label-for="input-d">
        <b-form-input
          id="input-d"
          v-model="form.name"
          type="text"
          required
          placeholder="Enter Name"
        ></b-form-input>
      </b-form-group>
      
      <b-form-group label="Location" label-for="input-b">
        <b-form-input
          id="input-b"
          v-model="form.location"
          type="text"
          
          placeholder="Enter Location"
        ></b-form-input>
      </b-form-group>
      
      <b-form-group label="Date (YYYY-MM-DD): " label-for="input-c">
        <b-form-input
          id="input-c"
          v-model="form.date"
          type="text"
          
          placeholder="Enter Date"
        ></b-form-input>
      </b-form-group>
      
      <b-form-group label="Price:" label-for="input-e">
        <b-form-input
          id="input-e"
          v-model="form.price"
          type="text"
          required
          placeholder="Enter Price"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Order Form HTML:" label-for="input-g">
        <b-form-textarea
          id="input-g"
          v-model="form.order_form"
          type="text"
          required
          placeholder="Enter Order form HTML"
          rows="4"
          max-rows="8"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group label="Delivery Address:" label-for="input-h">
        <b-form-input
          id="input-h"
          v-model="form.delivery_address"
          type="text"
          
          placeholder="Enter Delivery Address"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Imange URL Address:" label-for="input-h">
        <b-form-input
          id="input-h"
          v-model="form.image_url"
          type="text"
          
          placeholder="Enter Image URL"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Logo URL:" label-for="input-i">
        <b-form-input
          id="input-i"
          v-model="form.logo_url"
          type="text"
          
          placeholder="Enter logo URL"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Minimum Order Quantity:" label-for="input-j">
        <b-form-input
          id="input-j"
          v-model="form.moq"
          required
          type="text"
          placeholder="Enter Minimum Order Qty."
        ></b-form-input>
      </b-form-group>
      
      <b-alert class="m-2"
      :show="dismissCountDown"
      dismissible
      fade
      :variant="variant"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{responseMSG}}
    </b-alert>
    
      <b-button type="submit" variant="primary">Add Performance</b-button>
      <b-button v-on:click="cancel" variant="primary" class="ml-2">Close</b-button>
    </b-form>
   
    
    </b-col>

  </div>
</template>

<script>
/* eslint-disable */ 
  export default {
    name: "addPerformance",
    data() {
      return {
        form: {
          name: '',
          location: '',
          date: '',
          performance_id: '',
          price: '',
          order_form: '',
          delivery_address: '',
          image_url: '',
          moq: '',
          logo_url: ''
        },
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
        responseMSG: ''
      }
    },
    props: {
      authenticated: {}
    }, 
    methods: {
      onSubmit(evt) {
        evt.preventDefault()
        let currentObj = this;
        let params = new URLSearchParams();
        params.append('form', JSON.stringify(this.form))
        params.append('task', 'addperformance');
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    console.log(response.data) 
                    if (response.data.success) {
                        currentObj.showAlert("success", "Performance Added")
                    } else {
                        currentObj.showAlert("danger", "Performance NOT Added")
                    }
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
      cancel(evt) {
          this.$emit('menuItem', false)
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert(type, msg) {
        this.responseMSG = msg
        this.variant = type
        this.dismissCountDown = this.dismissSecs
      }

    }
  }
</script>
<style scoped>
.container {
     margin-top: 110px;


}
</style>